module.exports = __webpack_public_path__ + "static/media/10_r_otboynik_66.56_75.65.1456edf0.png";